/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import cn from "clsx";

export interface DropdownCustomTogglerProps {
  customClass?: string;
  onClick: any,
  children: any
  disabled?: boolean;
}
export const DropdownCustomToggler = React.forwardRef<HTMLButtonElement, DropdownCustomTogglerProps>((props, ref) => {
  return (
    <button
      ref={ref}
      className={cn("btn btn-clean btn-hover-light-primary btn-sm btn-icon", props.customClass)}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onClick(e);
      }}
      disabled={props.disabled}
    >
      {props.children}
    </button>
  );
});
